import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import "./StaticPage.css";

export type StaticPageKey = "home" | "privacyPolicy" | "userAgreement" | "serviceTerms";

export default function StaticPage({pageKey}: {pageKey: StaticPageKey}) {
  const {t} = useTranslation();
  const title = t(`staticPages.${pageKey}.title`);
  const body = t(`staticPages.${pageKey}.body`);

  useEffect(() => {
    document.title = `${title} · ID.Express`;
  }, [title]);

  return <article className="static-page">
    <h1>{title}</h1>
    {body.split("\n").filter(Boolean).map((paragraph, index) => <p key={index}>{paragraph}</p>)}
  </article>;
}
